import { TranslateService } from '@ngx-translate/core';
import { inject, Injectable } from '@angular/core';

import { ILinkId } from '@seb/web-design-system/core';
import { Product } from '@spartacus/core';

import '../models/augmented-spartacus-cart.model';
import { BaseStoreService } from '../services/base-store.service';

@Injectable({
  providedIn: 'root'
})
export class PdpNavigationService {
  private readonly baseStoreService = inject(BaseStoreService);
  private readonly translateService = inject(TranslateService);

  getActiveNavigation(product: Product): ILinkId[] {
    const links = [];
    const { activateAgecLaw } = this.baseStoreService.baseStore;
    if (!!product?.ssEditorialDescriptionTitle || !!product?.star?.title) {
      links.push({
        linkName: this.translateService.instant('pdp.sectionTitles.presentation'),
        url: 'presentation'
      });
    }
    if (product?.classifications?.length > 0 && activateAgecLaw && product?.['agecLaw']) {
      links.push({
        linkName: this.translateService.instant('pdp.sectionTitles.characteristics'),
        url: 'characteristics'
      });
    }
    if (
      product?.productReferences &&
      product?.productReferences['ACCESSORIES'] &&
      product?.productReferences['ACCESSORIES'].length > 0
    ) {
      links.push({
        linkName: this.translateService.instant('pdp.sectionTitles.accessories'),
        url: 'accessories'
      });
    }
    if (product?.reviews?.length > 0) {
      links.push({ linkName: this.translateService.instant('pdp.sectionTitles.review'), url: 'review' });
    }
    return links;
  }
}
